import { render, staticRenderFns } from "./CamposEditor.vue?vue&type=template&id=7dd2f1fc"
import script from "./CamposEditor.vue?vue&type=script&lang=js"
export * from "./CamposEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports